export interface IOption {
  key: string;
  parentKey?: string;
  value?: any;
  name: string;
  displayText?: string;
  default?: boolean;
  optionMetadata?: { [key: string]: any };
  isDirectInput?: boolean;
}

export enum FilterKeyValueType {
  FilterKey_OptionKey,
  FilterKey_OptionValue,
  FilterKey_OptionArray,
  OptionKey_KeywordValue,
  OptionKey_DateValue,
  OptionKey_OptionValue,
}

export interface IFilter {
  key?: string;
  type: FilterKeyValueType;
  label?: string;
  options: IOption[];
  availableOptions: IOption[];
  fieldType?: string;
  multiple?: boolean;
  parentKey?: string;
  pathParam?: string;
  dummyOptionName?: string;
  defaultOptionCode?: string;
  selectedOptions?: IOption | IOption[];
  searchKeyword?: string;
  essential?: boolean;
  isAutoFilled?: boolean; // 자동 입력된 상태 여부
  callback?: (selectedOptions?: IOption[] | IOption) => void;
}

// 새로운 부모-자식 관계 타입들
export interface ParentCustomCode {
  parentCodeGroup: string;
  parentCodeGroupName: string;
  parentUid: string;
  parentCode: string;
  parentCodeName: string;
  displayOrder: number;
}

export interface ChildCustomCode {
  childCodeGroup: string;
  childCodeGroupName: string;
  childUid: string;
  childCode: string;
  childCodeName: string;
  displayOrder: number;
}

// 필터 관계 맵 타입
export interface FilterRelationMap {
  [parentOptionUid: string]: {
    [childFilterGroup: string]: ChildCustomCode[];
  };
}

// 필터 그룹 코드 매핑
export enum FilterGroupCode {
  CAMPUS = "CPS",
  LINE_TIME = "LTM",
  LINE_DIRECTION = "LDR",
  LINE_DISTRICT = "LDT",
}

// 노선검색 필터 타입
export interface ILineSearchFilterOption {
  uid: string;
  code: string;
  codeName: string;
}

export interface ILineSearchFilter {
  codeGroup: string;
  codeGroupName: string;
  codes: ILineSearchFilterOption[];
}
